import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b7d9f29"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-row content-center justify-between w-32 h-10 text-sm rounded-md bg-chalk-dust-200" }

import IconComponent from '@/components/icon/IconComponent.vue';
import Icon from '@/components/icon/Icon';

export default /*#__PURE__*/_defineComponent({
  __name: 'DualSelectComponent',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "rounded-l selector",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('leftSelect')))
    }, [
      _renderSlot(_ctx.$slots, "left", {}, () => [
        _createVNode(IconComponent, {
          icon: _unref(Icon).DOUBLE_CHEVRON_LEFT
        }, null, 8, ["icon"])
      ])
    ]),
    _renderSlot(_ctx.$slots, "middle"),
    _createElementVNode("button", {
      class: "rounded-r selector",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('rightSelect')))
    }, [
      _renderSlot(_ctx.$slots, "right", {}, () => [
        _createVNode(IconComponent, {
          icon: _unref(Icon).DOUBLE_CHEVRON_RIGHT
        }, null, 8, ["icon"])
      ])
    ])
  ]))
}
}

})